import { ApplicationConfig, importProvidersFrom } from "@angular/core";
import { provideRouter } from "@angular/router";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { routes } from "./app.routes";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { provideToastr } from "ngx-toastr";
import { ConfirmationService } from "primeng/api";
import { jwtInterceptor } from "../Utils/_interceptors/jwt.interceptor";
import { providePrimeNG } from "primeng/config";
import Lara from "@primeuix/themes/lara";
import { networkErrorInterceptor } from "../Utils/_interceptors/network-error.interceptor";

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptors([
      networkErrorInterceptor,
      jwtInterceptor
    ])),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Lara,
        options: {
          prefix: "p",
          darkModeSelector: false,
          cssLayer: false,
        },
      },
    }),
    provideToastr(),
    ConfirmationService,
  ],
};
